import * as yup from 'yup'

import {
  requiredString
} from '../yup/schemas.js'

export const adminSchema = yup.object({
  id: requiredString.uuid(),
  email: requiredString.email().toLowerCase(),
  password: requiredString.password()
}).objectRequired()

const createAdminSchema = adminSchema.pick(['email', 'password'])

const getAdminParamsSchema = adminSchema.pick(['id'])

const createAdminSchemas = { back: createAdminSchema }

const getAdminParamsSchemas = { front: getAdminParamsSchema, back: getAdminParamsSchema }

export default {
  createAdmin: createAdminSchemas,
  getAdminParams: getAdminParamsSchemas
}
